import React, { useState, useEffect } from 'react';
import { 
  FaFish, 
  FaShoppingCart, 
  FaEye, 
  FaStar, 
  FaTruck, 
  FaLeaf, 
  FaShieldAlt, 
  FaChartLine,
  FaCrown,
  FaGem,
  FaCoins,
  FaWhatsapp,
  FaPhone,
  FaEnvelope,
  FaWeightHanging,
  FaBox,
  FaSpinner
} from 'react-icons/fa';
import { 
  GiFishing, 
  GiHealthIncrease, 
  GiOrganic,
  GiLion
} from 'react-icons/gi';
import { 
  MdVerified,
  MdCategory
} from 'react-icons/md';

import viral from "../assests/Premium Fish Feed with Sapphire Splash Background.png"
import mrigal from "../assests/Premium Fish Feed with Sapphire Splash Background (5).png"
import talapia from "../assests/Premium Fish Feed with Sapphire Splash Background (4).png"
import fungash from "../assests/Premium Fish Feed with Sapphire Splash Background (3).png"
import Catla from "../assests/Premium Fish Feed with Sapphire Splash Background (2).png"
import Rohu from "../assests/Premium Fish Feed with Sapphire Splash Background (1).png"

// Optimized image component with lazy loading and loading state
const OptimizedImage = ({ src, alt, className }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);

  return (
    <div className={`relative overflow-hidden bg-gradient-to-br from-gray-100 to-gray-200 ${className}`}>
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center">
          <FaSpinner className="text-3xl text-orange-500 animate-spin" />
        </div>
      )}
      {error && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-200">
          <span className="text-gray-500 text-sm">Image not available</span>
        </div>
      )}
      <img
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        onLoad={() => setIsLoading(false)}
        onError={() => {
          setIsLoading(false);
          setError(true);
        }}
        className={`w-full h-full object-cover transition-opacity duration-300 ${
          isLoading ? 'opacity-0' : 'opacity-100 group-hover:scale-110'
        }`}
      />
    </div>
  );
};

const fishFeedProducts = [
  {
    id: 1,
    name: 'Viral Fish Feed Bag',
    category: 'Premium',
    weight: '25kg',
    protein: 'Protein 48%',
    price: 1850,
    oldPrice: 2100,
    description: 'High-protein feed for rapid growth and immunity boost',
    image: viral,
    badge: 'Best Seller',
    rating: 4.8,
    reviews: 124,
    inStock: true
  },
  {
    id: 2,
    name: 'Rohu Fish Feed Bag',
    category: 'Specialty',
    weight: '25kg',
    protein: 'Protein 28%',
    price: 1350,
    oldPrice: 1900,
    description: 'Specially formulated for Rohu fish growth and health',
    image: Rohu,
    badge: 'Popular',
    rating: 4.6,
    reviews: 89,
    inStock: true
  },
  {
    id: 3,
    name: 'Catla Fish Feed Bag',
    category: 'Specialty',
    weight: '25kg',
    protein: 'Protein 28%',
    price: 1350,
    oldPrice: 1900,
    description: 'Optimized nutrition for Catla fish species',
    image: Catla,
    badge: null,
    rating: 4.5,
    reviews: 67,
    inStock: true
  },
  {
    id: 4,
    name: 'Fungash Fish Feed Bag',
    category: 'Premium',
    weight: '25kg',
    protein: 'Protein 28%',
    price: 1350,
    oldPrice: 2000,
    description: 'Enhanced formula for fungal resistance and growth',
    image: fungash,
    badge: 'New',
    rating: 4.7,
    reviews: 45,
    inStock: true
  },
  {
    id: 5,
    name: 'Tilapia Fish Feed Bag',
    category: 'Standard',
    weight: '25kg',
    protein: 'Protein 28%',
    price: 1350,
    oldPrice: 1800,
    description: 'Balanced nutrition for Tilapia farming',
    image: talapia,
    badge: null,
    rating: 4.4,
    reviews: 112,
    inStock: true
  },
  {
    id: 6,
    name: 'Mrigal Fish Feed Bag',
    category: 'Specialty',
    weight: '25kg',
    protein: 'Protein 28%',
    price: 1350,
    oldPrice: 1850,
    description: 'Specialized feed for Mrigal fish species',
    image: mrigal,
    badge: null,
    rating: 4.5,
    reviews: 56,
    inStock: true
  },
  {
    id: 7,
    name: 'Viral Fish Feed Bag',
    category: 'Premium',
    weight: '40kg',
    protein: 'Protein 48%',
    price: 2880,
    oldPrice: 3860,
    description: 'High-protein feed for rapid growth and immunity boost',
    image: viral,
    badge: 'Best Seller',
    rating: 4.8,
    reviews: 124,
    inStock: true
  },
  {
    id: 8,
    name: 'Rohu Fish Feed Bag',
    category: 'Specialty',
    weight: '40kg',
    protein: 'Protein 28%',
    price: 1680,
    oldPrice: 2160,
    description: 'Specially formulated for Rohu fish growth and health',
    image: Rohu,
    badge: 'Popular',
    rating: 4.6,
    reviews: 89,
    inStock: true
  },
  {
    id: 9,
    name: 'Catla Fish Feed Bag',
    category: 'Specialty',
    weight: '40kg',
    protein: 'Protein 28%',
    price: 1680,
    oldPrice: 2160,
    description: 'Optimized nutrition for Catla fish species',
    image: Catla,
    badge: null,
    rating: 4.5,
    reviews: 67,
    inStock: true
  },
  {
    id: 10,
    name: 'Fungash Fish Feed Bag',
    category: 'Premium',
    weight: '40kg',
    protein: 'Protein 28%',
    price: 1680,
    oldPrice: 2160,
    description: 'Enhanced formula for fungal resistance and growth',
    image: fungash,
    badge: 'New',
    rating: 4.7,
    reviews: 45,
    inStock: true
  },
  {
    id: 11,
    name: 'Tilapia Fish Feed Bag',
    category: 'Standard',
    weight: '40kg',
    protein: 'Protein 28%',
    price: 1680,
    oldPrice: 2160,
    description: 'Balanced nutrition for Tilapia farming',
    image: talapia,
    badge: null,
    rating: 4.4,
    reviews: 112,
    inStock: true
  },
  {
    id: 12,
    name: 'Mrigal Fish Feed Bag',
    category: 'Specialty',
    weight: '40kg',
    protein: 'Protein 28%',
    price: 1680,
    oldPrice: 2160,
    description: 'Specialized feed for Mrigal fish species',
    image: mrigal,
    badge: null,
    rating: 4.5,
    reviews: 56,
    inStock: true
  },
];

const ProductShowcase = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [hoveredProduct, setHoveredProduct] = useState(null);
  const [showQuickView, setShowQuickView] = useState(null);
  const [showInquiryModal, setShowInquiryModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [visibleProducts, setVisibleProducts] = useState(12);
  const [inquiryForm, setInquiryForm] = useState({
    name: '',
    phone: '',
    quantity: '',
    message: ''
  });

  const categories = [
    { id: 'all', name: 'All Products', icon: <FaBox className="text-lg" />, color: 'from-gray-500 to-gray-600' },
    { id: 'Premium', name: 'Premium', icon: <FaCrown className="text-lg" />, color: 'from-amber-500 to-amber-600' },
    { id: 'Specialty', name: 'Specialty', icon: <FaGem className="text-lg" />, color: 'from-purple-500 to-purple-600' },
    { id: 'Standard', name: 'Standard', icon: <FaFish className="text-lg" />, color: 'from-blue-400 to-blue-500' }
  ];

  const filteredProducts = selectedCategory === 'all' 
    ? fishFeedProducts 
    : fishFeedProducts.filter(product => product.category === selectedCategory);

  const displayedProducts = filteredProducts.slice(0, visibleProducts);

  const handleInquiry = (product) => {
    setSelectedProduct(product);
    setShowInquiryModal(true);
  };

  const handleInquirySubmit = (e) => {
    e.preventDefault();
    const message = `Product Inquiry:\nProduct: ${selectedProduct.name}\nWeight: ${selectedProduct.weight}\nName: ${inquiryForm.name}\nPhone: ${inquiryForm.phone}\nQuantity: ${inquiryForm.quantity}\nMessage: ${inquiryForm.message}`;
    const phoneNumber = "918072621187";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    
    window.open(whatsappUrl, '_blank');
    setShowInquiryModal(false);
    setInquiryForm({ name: '', phone: '', quantity: '', message: '' });
  };

  const loadMore = () => {
    setVisibleProducts(prev => prev + 8);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50">
      {/* Hero Section */}
      <div className="relative overflow-hidden bg-[#1770b6]">
        <div className="absolute inset-0 bg-black opacity-20"></div>
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-white rounded-full opacity-10 blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-yellow-400 rounded-full opacity-10 blur-3xl"></div>
        
        <div className="relative max-w-7xl mx-auto px-4 py-16 md:py-24 text-center">
          <div className="inline-flex items-center gap-3 bg-white/20 backdrop-blur-sm rounded-full px-6 py-2 mb-6">
            <GiLion className="text-2xl text-yellow-200 animate-pulse" />
            <span className="text-white font-semibold">Since 1995</span>
            <MdVerified className="text-yellow-300 text-xl" />
          </div>
          
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Lion Head
            <span className="block text-3xl md:text-4xl mt-2 text-gray-900">Premium Quality Fish Feed</span>
          </h1>
          
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Trusted by farmers across India for superior quality, high protein content, and exceptional growth results
          </p>
          
          <div className="flex flex-wrap justify-center gap-3 mb-8">
            {['✓ Premium Quality', '✓ High Protein (28-48%)', '✓ Fast Growth', '✓ 100% Natural', '✓ Pan India Delivery'].map((badge, idx) => (
              <span key={idx} className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-white text-sm font-medium">
                {badge}
              </span>
            ))}
          </div>
          
          <div className="flex flex-wrap justify-center gap-4">
            <button className="bg-white text-gray-900 px-8 py-3 rounded-full font-semibold hover:shadow-lg transition-all hover:scale-105 flex items-center gap-2">
              <FaWhatsapp className="text-green-500" /> Contact Sales
            </button>
            <button className="border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white/10 transition-all flex items-center gap-2">
              <FaPhone /> Call Now
            </button>
          </div>
        </div>
      </div>

      {/* Category Filter */}
      <div className="sticky top-0 z-50 bg-white/95 backdrop-blur-md shadow-md border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex gap-3 overflow-x-auto scrollbar-hide justify-center flex-wrap">
            {categories.map(category => (
              <button
                key={category.id}
                onClick={() => {
                  setSelectedCategory(category.id);
                  setVisibleProducts(12);
                }}
                className={`
                  flex items-center gap-2 px-5 py-2.5 rounded-full font-medium transition-all duration-300 whitespace-nowrap
                  ${selectedCategory === category.id 
                    ? `bg-gradient-to-r ${category.color} text-white shadow-lg transform scale-105` 
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }
                `}
              >
                {category.icon}
                <span>{category.name}</span>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Products Grid */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
          {displayedProducts.map((product) => (
            <div
              key={product.id}
              className="group relative bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
              onMouseEnter={() => setHoveredProduct(product.id)}
              onMouseLeave={() => setHoveredProduct(null)}
            >
              {/* Image Container with Optimized Image Component */}
              <div className="relative h-56 md:h-60">
                <OptimizedImage
                  src={product.image}
                  alt={product.name}
                  className="h-full w-full"
                />
                
                {/* Badges */}
                <div className="absolute top-3 left-3 flex flex-col gap-2 z-10">
                  {product.badge && (
                    <span className={`text-white text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1 shadow-lg ${
                      product.badge === 'Best Seller' ? 'bg-gradient-to-r from-red-500 to-orange-500' :
                      product.badge === 'Popular' ? 'bg-gradient-to-r from-blue-500 to-cyan-500' :
                      product.badge === 'New' ? 'bg-gradient-to-r from-green-500 to-emerald-500' :
                      'bg-gradient-to-r from-purple-500 to-pink-500'
                    }`}>
                      {product.badge}
                    </span>
                  )}
                  {product.category === 'Premium' && !product.badge && (
                    <span className="bg-gradient-to-r from-amber-500 to-orange-500 text-white text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1 shadow-lg">
                      <FaCrown className="text-xs" /> PREMIUM
                    </span>
                  )}
                </div>
                
                {/* Rating */}
                <div className="absolute top-3 right-3 bg-black/70 backdrop-blur-sm px-2 py-1 rounded-lg flex items-center gap-1 z-10">
                  <FaStar className="text-yellow-400 text-xs" />
                  <span className="text-white text-xs font-bold">{product.rating}</span>
                  <span className="text-gray-300 text-xs">({product.reviews})</span>
                </div>
                
                {/* Weight Badge */}
                <div className="absolute bottom-3 left-3 bg-black/60 backdrop-blur-sm px-3 py-1 rounded-full flex items-center gap-1 z-10">
                  <FaWeightHanging className="text-white text-xs" />
                  <span className="text-white text-xs font-medium">{product.weight}</span>
                </div>
                
                {/* Hover Overlay */}
                {hoveredProduct === product.id && (
                  <div className="absolute inset-0 bg-black/50 flex items-center justify-center gap-3 transition-all duration-300 z-20">
                    <button 
                      onClick={() => setShowQuickView(product.id)}
                      className="bg-white text-gray-800 p-3 rounded-full hover:bg-orange-500 hover:text-white transition-all transform hover:scale-110"
                    >
                      <FaEye className="text-xl" />
                    </button>
                    <button 
                      onClick={() => handleInquiry(product)}
                      className="bg-orange-500 text-white p-3 rounded-full hover:bg-orange-600 transition-all transform hover:scale-110"
                    >
                      <FaShoppingCart className="text-xl" />
                    </button>
                  </div>
                )}
              </div>
              
              {/* Product Info */}
              <div className="p-4">
                <h3 className="text-lg font-bold text-gray-800 mb-1 line-clamp-1">{product.name}</h3>
                <p className="text-gray-600 text-xs mb-2 line-clamp-2">{product.description}</p>
                
                {/* Protein & Category */}
                <div className="flex justify-between items-center mb-3 text-xs">
                  <div className="flex items-center gap-1 text-green-600 font-semibold">
                    <GiHealthIncrease className="text-sm" />
                    <span>{product.protein}</span>
                  </div>
                  <div className="flex items-center gap-1 text-orange-600">
                    <MdCategory className="text-sm" />
                    <span>{product.category}</span>
                  </div>
                </div>
                
                {/* Price & CTA */}
                <div className="flex items-center justify-between">
                  <div>
                    <span className="text-xl font-bold text-gray-900">₹{product.price.toLocaleString()}</span>
                    <span className="text-gray-400 text-xs line-through ml-2">₹{product.oldPrice.toLocaleString()}</span>
                  </div>
                  <button 
                    onClick={() => handleInquiry(product)}
                    className="bg-gradient-to-r from-green-500 to-green-600 text-white px-3 py-1.5 rounded-lg text-sm font-semibold hover:shadow-lg transition-all flex items-center gap-1"
                  >
                    <FaWhatsapp className="text-sm" /> Inquiry
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Load More Button */}
        {visibleProducts < filteredProducts.length && (
          <div className="text-center mt-12">
            <button
              onClick={loadMore}
              className="bg-gradient-to-r from-orange-500 to-amber-500 text-white px-8 py-3 rounded-full font-semibold hover:shadow-lg transition-all hover:scale-105"
            >
              Load More Products
            </button>
          </div>
        )}
      </div>

      {/* Features Section */}
      <div className="bg-gradient-to-br from-gray-900 to-gray-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">Why Choose Lion Head?</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: <GiHealthIncrease className="text-4xl text-green-400" />, title: "Premium Ingredients", desc: "Made from high-quality natural ingredients" },
              { icon: <FaChartLine className="text-4xl text-blue-400" />, title: "High Protein Content", desc: "Up to 48% protein for accelerated growth" },
              { icon: <FaShieldAlt className="text-4xl text-amber-400" />, title: "Disease Resistance", desc: "Formulated with immunity boosters" },
              { icon: <FaTruck className="text-4xl text-orange-400" />, title: "Pan India Delivery", desc: "Fast shipping across all major cities" }
            ].map((feature, idx) => (
              <div key={idx} className="text-center group">
                <div className="flex justify-center mb-4 transform group-hover:scale-110 transition-transform">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
                <p className="text-gray-300">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-[#1770b6] py-16">
        <div className="max-w-4xl mx-auto text-center px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Ready to Boost Your Fish Growth?</h2>
          <p className="text-xl text-white/90 mb-8">Contact us for bulk orders and special pricing</p>
          <div className="flex flex-wrap justify-center gap-4">
            <button className="bg-white text-gray-600 px-8 py-3 rounded-full font-semibold hover:shadow-xl transition-all hover:scale-105 flex items-center gap-2">
              <FaWhatsapp className="text-green-500 text-xl" /> Contact Sales
            </button>
            <button className="border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white/10 transition-all flex items-center gap-2">
              <FaEnvelope /> Get Quote
            </button>
          </div>
        </div>
      </div>

      {/* Inquiry Modal */}
      {showInquiryModal && selectedProduct && (
        <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4" onClick={() => setShowInquiryModal(false)}>
          <div className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="p-6">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-2xl font-bold text-gray-800">Product Inquiry</h3>
                <button onClick={() => setShowInquiryModal(false)} className="text-gray-400 hover:text-gray-600 text-2xl">&times;</button>
              </div>
              
              <div className="mb-4 p-3 bg-orange-50 rounded-lg">
                <p className="font-semibold text-gray-800">{selectedProduct.name}</p>
                <p className="text-sm text-gray-600">Weight: {selectedProduct.weight} | {selectedProduct.protein}</p>
                <p className="text-lg font-bold text-gray-900 mt-1">₹{selectedProduct.price.toLocaleString()}</p>
              </div>
              
              <form onSubmit={handleInquirySubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Full Name *</label>
                  <input
                    type="text"
                    required
                    value={inquiryForm.name}
                    onChange={(e) => setInquiryForm({...inquiryForm, name: e.target.value})}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
                    placeholder="Enter your name"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number *</label>
                  <input
                    type="tel"
                    required
                    value={inquiryForm.phone}
                    onChange={(e) => setInquiryForm({...inquiryForm, phone: e.target.value})}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
                    placeholder="Enter your phone number"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Quantity (Bags)</label>
                  <input
                    type="number"
                    value={inquiryForm.quantity}
                    onChange={(e) => setInquiryForm({...inquiryForm, quantity: e.target.value})}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
                    placeholder="Enter quantity"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
                  <textarea
                    rows="3"
                    value={inquiryForm.message}
                    onChange={(e) => setInquiryForm({...inquiryForm, message: e.target.value})}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
                    placeholder="Any specific requirements?"
                  ></textarea>
                </div>
                
                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-green-500 to-green-600 text-white py-3 rounded-lg font-semibold hover:shadow-lg transition-all flex items-center justify-center gap-2"
                >
                  <FaWhatsapp className="text-xl" /> Send Inquiry on WhatsApp
                </button>
              </form>
              
              <p className="text-xs text-gray-500 text-center mt-4">
                We'll contact you shortly with pricing and availability
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Quick View Modal */}
      {showQuickView && (
        <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4" onClick={() => setShowQuickView(null)}>
          <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="p-6">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-2xl font-bold text-gray-800">Product Details</h3>
                <button onClick={() => setShowQuickView(null)} className="text-gray-400 hover:text-gray-600 text-2xl">&times;</button>
              </div>
              {(() => {
                const product = fishFeedProducts.find(p => p.id === showQuickView);
                return product ? (
                  <div>
                    <OptimizedImage
                      src={product.image}
                      alt={product.name}
                      className="w-full h-64 rounded-lg mb-4"
                    />
                    <h4 className="text-xl font-bold text-gray-800">{product.name}</h4>
                    <div className="flex items-center gap-4 my-2">
                      <span className="text-2xl font-bold text-orange-600">₹{product.price.toLocaleString()}</span>
                      <span className="text-gray-400 line-through">₹{product.oldPrice.toLocaleString()}</span>
                    </div>
                    <p className="text-gray-600 mb-4">{product.description}</p>
                    <div className="grid grid-cols-2 gap-3 mb-4">
                      <div className="bg-gray-100 p-2 rounded-lg text-center">
                        <p className="text-sm text-gray-500">Weight</p>
                        <p className="font-semibold">{product.weight}</p>
                      </div>
                      <div className="bg-gray-100 p-2 rounded-lg text-center">
                        <p className="text-sm text-gray-500">Protein</p>
                        <p className="font-semibold text-green-600">{product.protein}</p>
                      </div>
                    </div>
                    <button 
                      onClick={() => {
                        setShowQuickView(null);
                        handleInquiry(product);
                      }}
                      className="w-full bg-gradient-to-r from-orange-500 to-amber-500 text-white py-3 rounded-lg font-semibold flex items-center justify-center gap-2"
                    >
                      <FaWhatsapp /> Get Best Price
                    </button>
                  </div>
                ) : null;
              })()}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductShowcase;